import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Typography,
    Paper,
    Divider
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    mailPreview: {
        width: '100%',
        maxHeight: '35rem',
        overflowY: 'auto',
    },
    previewItem: {
        display: 'flex',
        marginBottom: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    label: {
        fontWeight: 'bold',
        color: '#26344a',
        fontSize: '1.6rem',
        minWidth: '120px',
        marginRight: theme.spacing(2),
        flexShrink: 0,
    },
    value: {
        color: '#4a4a4a',
        fontSize: '1.6rem',
        lineHeight: 1.6,
        flex: 1,
        wordBreak: 'break-word',
    },
    messageValue: {
        color: '#4a4a4a',
        fontSize: '1.6rem',
        lineHeight: 1.6,
        flex: 1,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        backgroundColor: '#f9f9f9',
        padding: theme.spacing(2),
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        maxHeight: '20rem',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    attachmentsValue: {
        color: '#3273dc',
        fontSize: '1.6rem',
        lineHeight: 1.6,
        flex: 1,
        fontStyle: 'italic',
    },
}));

const MailPreview = ({ formData }) => {
    const classes = useStyles();

    if (!formData) return null;

    let fileNames = [];
    if (formData.attachments) {
        formData.attachments.forEach(attachment => {
            fileNames.push(attachment.name);
        })
    }

    return (
        <Box className={classes.mailPreview}>
            <Box className={classes.previewItem}>
                <Typography variant="body1" className={classes.label}>
                    件名
                </Typography>
                <Typography variant="body1" className={classes.value}>
                    {formData.title}
                </Typography>
            </Box>

            <Box className={classes.previewItem}>
                <Typography variant="body1" className={classes.label}>
                    送信者名
                </Typography>
                <Typography variant="body1" className={classes.value}>
                    {formData.name}
                </Typography>
            </Box>

            <Box className={classes.previewItem}>
                <Typography variant="body1" className={classes.label}>
                    本文
                </Typography>
                <Typography variant="body1" className={classes.messageValue}>
                    {formData.message}
                </Typography>
            </Box>

            {fileNames.length > 0 && (
                <Box className={classes.previewItem}>
                    <Typography variant="body1" className={classes.label}>
                        添付ファイル
                    </Typography>
                    <Typography variant="body1" className={classes.attachmentsValue}>
                        {fileNames.join(' , ')}
                    </Typography>
                </Box>
            )}
        </Box>
    )
}

MailPreview.propTypes = {
    formData: PropTypes.object
}

export default MailPreview
